import React from 'react';
import { Modal } from 'react-bootstrap';
import styles from './TermsAndPrivacy.module.scss';

export const defaultProps = {
  show: false,
  modalBodyContent: '',
  handleClose: (): void => { },
};

export type TermsAndPrivacyProps = {
  modalBodyContent?: string | undefined;
  handleClose?: () => void;
  show?: boolean;

};

const TermsAndPrivacy: React.FC<TermsAndPrivacyProps> = ({
  modalBodyContent = '',
  handleClose,
  show,
}) => {

  return (
    <Modal
      className={styles.modal}
      dialogClassName={styles.modalDialog}
      contentClassName={styles.modalContent}
      show={show}
      onHide={handleClose}
    >
      <Modal.Header className={styles.modalHeader}
        closeButton
        closeLabel=''>
      </Modal.Header>
      <div dangerouslySetInnerHTML={{ __html: modalBodyContent }}></div>
    </Modal>
  );
};

TermsAndPrivacy.defaultProps = defaultProps;

export default TermsAndPrivacy;